if (!customElements.get('browprint-tutorial')) {
  customElements.define(
    'browprint-tutorial',
    class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('[data-bpt-play]');
        if (!button) return;

        button.addEventListener(
          'click',
          () => {
            const videoId = button.dataset.videoId;
            if (!videoId) return;

            const iframe = document.createElement('iframe');
            iframe.className = 'bpt__iframe';
            iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`;
            iframe.title = 'How to use the Soraderma BrowPrint System';
            iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
            iframe.allowFullscreen = true;
            iframe.referrerPolicy = 'strict-origin-when-cross-origin';

            button.replaceWith(iframe);
            iframe.focus();
          },
          { once: true }
        );
      }
    }
  );
}
